import { flexRender, Header } from '@tanstack/react-table';
import { TableCell } from '@mui/material';

interface SortableTableHeaderProps<TData> {
  header: Header<TData, unknown>;
  isLoading?: boolean;
  hasData?: boolean;
}

export function SortableTableHeader<TData>({
  header,
  isLoading = false,
  hasData = true
}: Readonly<SortableTableHeaderProps<TData>>) {
  const canSort = header.column.getCanSort();
  const isSorted = header.column.getIsSorted();

  return (
    <TableCell
      key={header.id}
      onClick={!isLoading && hasData ? header.column.getToggleSortingHandler() : undefined}
      sx={{
        fontWeight: '500',
        whiteSpace: 'nowrap',
        backgroundColor: 'background.paper',
        color: 'grey.600',
        fontSize: '12px',
        cursor: canSort ? 'pointer' : 'default'
      }}
      className="hover:text-primary-main group"
    >
      {flexRender(header.column.columnDef.header, header.getContext())}
      {canSort && (
        <span
          className={`${
            isSorted ? 'opacity-100' : 'opacity-0'
          } group-hover:opacity-100 transition-opacity`}
        >
          {isSorted === 'desc' ? ' ↓' : ' ↑'}
        </span>
      )}
    </TableCell>
  );
}
